/**
 * The one text match (UI cleanup U2): every word of the query occurs in one of the fields, ignoring case, in any
 * order. Used by search, the Notebook's search and the filter's *Title or notes contain* (which runs on the server
 * too: `server/drang/core/filter.py` `_text_matches` follows the same rule). Before, search matched the starts of
 * words and the other two one unbroken piece of text.
 */
export function matchesText(fields: string[], query: string): boolean {
  const words = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (!words.length) return true;
  const hay = fields.map((f) => f.toLowerCase());
  return words.every((w) => hay.some((h) => h.includes(w)));
}
